module.exports = __webpack_public_path__ + "img/title12.96e9c981.png";